/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguests2Inputs */

const en_statsroomguests2 = /** @type {(inputs: Statsroomguests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests`)
};

const de_statsroomguests2 = /** @type {(inputs: Statsroomguests2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste`)
};

/**
* | output |
* | --- |
* | "Guests" |
*
* @param {Statsroomguests2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguests2 = /** @type {((inputs?: Statsroomguests2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguests2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguests2(inputs)
	return de_statsroomguests2(inputs)
});
export { statsroomguests2 as "statsRoomGuests" }